import React from "react";
import { Link } from "react-router-dom";

const TopicOne = () => {
  return (
    <div className="quality-section-market">
      <div className="quality-header-market">
        <h1>Invest in the World’s Leading Companies</h1>
        <p>
          The stock market is where innovation meets opportunity. Whether you’re
          trading tech giants like Apple and Tesla or global leaders like Nestlé
          and Samsung, The Pips gives you direct access to top-performing global
          equities, all in one place. 
          {/* With real-time data, tight spreads, and
          flexible leverage, you can diversify your portfolio and capitalize on
          the movements of some of the world’s most influential companies. */}
        </p>
      </div>
    </div>
  );
};

export default TopicOne;
